import App from './App';


// export const Init = () => {
//   App();
// }

App();
